<template>
    <div style="width: 100%;">
        <nav class="nav nav-pills flex-column side-menu ps-2" :data-uid="menu.uid" v-for="(menu, sindex) in menus" :key="sindex">
            <div class="nav-link mw-100" :class="{'nav-active':menu.uid == $route.params.child_id}" :href="menu.url" @mouseover="hover[menu.uid] = true" @mouseout="hover[menu.uid] = false">
                <span class="d-flex align-items-center w-100 mw-100 nav-link-child text-truncate" @click="openTopic(menu.uid)">
                    <span :class="(menu.menu.length ? 'ps-2' : 'ps-5')">{{menu.name}}</span>
                </span>
                <div v-show="hover[menu.uid]" v-if="menu.admin === true">
                    <div class="d-flex flex-row">
                        <div class="dropdown">
                            <a href="" class="option-item dropdown-toggle text-dark" data-bs-toggle="dropdown"><i class="mdi mdi-dots-vertical"></i></a>
                            <ul class="dropdown-menu">
                                <li><button class="dropdown-item" type="button" @click="$emitter.emit('show_add_topic', {callback:updateTopic,data:menu.name,parent:menu.id});"><i class="mdi mdi-pencil"></i> Edit</button></li>
                                <li><button class="dropdown-item" type="button" @click="$emitter.emit('delete_modal_show', [deleteTopic, menu.id]);"><i class="mdi mdi-trash-can"></i> Move to Trash</button></li>
                            </ul>
                        </div>
                        <a class="option-item text-primary" @click="$emitter.emit('show_add_topic', {callback:addTopic,parent:menu.id});"><i class="mdi mdi-plus-circle"></i></a>    
                    </div>
                </div>

                <a class="option-item" v-if="menu.menu.length > 0" @click="show[menu.uid] = !show[menu.uid];"><i class="mdi" :class="{'mdi-chevron-down':!show[menu.uid], 'mdi-chevron-up':show[menu.uid]}"></i></a>

            </div>
            <transition name="fade">
                <SubMenu :menus="menu.menu" :index="menu.uid" v-show="show[menu.uid]" />
            </transition>
        </nav>
    </div>
</template>

<script>
import SubMenu from './SubMenu';
export default {
    components: {
        SubMenu  
    },
    props: {
        menus: Array,
        index: String
    },
    data() {
        return {
            hover: {},
            show: {}
        }
    },
    methods: {
        addTopic(topic, parent) {
            this.$emitter.emit('addTopic', [topic,parent]);
        },
        updateTopic(topic, parent) {
            this.$emitter.emit('updateTopic', [topic,parent]);
        },
        deleteTopic(id) {
            this.$emitter.emit('deleteTopic', id);
        },
        openTopic(uid) {
            this.$emitter.emit('openTopic', uid);
        }
    }
}
</script>

<style scoped>
.dropdown-menu {
    border-radius: 3px;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    border: 0.4px solid #ffffff;
    padding: 0;
    width: 20vw;
}

.side-menu nav {
    margin-bottom: 0;
}

.side-menu .nav-link {
    border-radius: 4px;
    padding: 5px 10px;
    font-weight: 600;
    color: #585858;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    height: 38px;
}

.side-menu .nav-link:hover, .side-menu .nav-link.nav-active {
    background: #efefef;
}

.option-item {
    padding: 0 7px;
    border-radius: 4px;
    justify-content: center;
    transition: 0.3s;
    font-size: 19px;
    font-weight: 500;
}

.option-item:hover {
    background: #c9c9c96b;
}

.dropdown-toggle::after {
    display: none !important;
}

.dropdown-item.active, .dropdown-item:active {
    background-color: #6696e8;
}

.dropdown-item {
    font-size: 14px;
    font-weight: 600;
    padding: 7px 16px;
    color: #424242d4;
}

.dropdown-item .mdi {
    margin-right: 10px;
    opacity: 0.4;
}

.dropdown-item.active, .dropdown-item:active {
    background-color: #6696e8;
    color: #fff;
}

.bg-primary {
    background-color: var(--primary-color) !important;
}

.text-primary {
    color: var(--primary-color) !important;
}
</style>